import React from "react";
import styled from "styled-components";
import CameraOnIcon from "@icons/Rooms/CamOn.svg";
import Styles from "@themes/Styles";

const LinkWrapper = styled.a`
    text-decoration: none;
    color: inherit;
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.borderPrimary};
    border-radius: ${Styles.borderRadiusSharp};
    overflow: auto;
    height: 100%;
`;

const Thumbnail = styled.img`
    height: 180px;
    object-fit: cover;
`;

const LowerHalf = styled.div`
    flex: 1;
    padding: 23px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const InfoBlock = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const RoomName = styled.span`
    font-size: 16px;
`;

const RoomDescription = styled.p`
    margin-top: 8px;
    font-size: 13px;
    color: ${({ theme }) => theme.textColorSecondary};
    white-space: pre-line;
`;

const StatusBlock = styled.div`
    margin-top: 24px;
    font-size: 14px;
`;

const IndicatorDot = styled.div`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
`;

const LiveIndicatorDot = styled(IndicatorDot)`
    background-color: lime;
`;

const CameraIcon = styled(CameraOnIcon)`
    fill: ${(props) => props.theme.textColorPrimary};
`;

const InlineIcon = styled.span`
    display: inline-block;
    vertical-align: middle;
`;

type DynamicLobbyInfoCardProps = {
    roomLink: string;
    thumbnailUrl: string;
    roomName: string;
    roomDescription: string;
    guestCount: number;
    videoCallParticipantCount: number;
};

export default function DynamicLobbyInfoCardLayout({
    roomLink,
    thumbnailUrl,
    roomName,
    roomDescription,
    guestCount,
    videoCallParticipantCount,
}: DynamicLobbyInfoCardProps) {
    const activeVideo = videoCallParticipantCount > 0;
    const active = activeVideo || guestCount > 0;
    return (
        <LinkWrapper href={roomLink} target="_top">
            <CardContainer>
                <Thumbnail src={thumbnailUrl} />
                <LowerHalf>
                    <InfoBlock>
                        <RoomName>{roomName}</RoomName>
                        <RoomDescription>{roomDescription}</RoomDescription>
                    </InfoBlock>
                    {active && (
                        <StatusBlock>
                            <LiveIndicatorDot />
                            {guestCount > 0 && `${guestCount} online`}
                            {activeVideo && (
                                <>
                                    {" | "}
                                    <InlineIcon>
                                        <CameraIcon />
                                    </InlineIcon>
                                    {videoCallParticipantCount > 0 && ` ${videoCallParticipantCount} on video`}
                                </>
                            )}
                        </StatusBlock>
                    )}
                </LowerHalf>
            </CardContainer>
        </LinkWrapper>
    );
}
